//引入VueRouter
import VueRouter from 'vue-router'


const router = new VueRouter({
	routes:[
		//主页
		{  
			name:'mainPage',
			path:'/',
			component:()=>import('../pages/mainPage/mainPage.vue')
		},
	]
})

//避免重复跳转 捕获错误
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

//暴露router
export default router